<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">コギト管理画面</span>
			</div>
			<div class="uk-navbar-right">
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<!--/ Main -->
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div id="cgt_manage_link_list" class="uk-child-width-1-2@s uk-child-width-1-2@m uk-text-center" uk-grid>
				<!-- <div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/export/data">データ取得</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/import_work_schedule">勤怠マスタデータのインポート</router-link>
				</div> -->
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/job_type">業務マスタ</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/skill_attribute">スキルマスタ</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/job_position">役割マスタ</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/todo_type">ToDoカテゴリマスタ</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/shop">店舗マスタ</router-link>
				</div>
				<!-- <div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/shop_search">店舗検索</router-link>
				</div> -->
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/staff">スタッフマスタ</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/import_main_office_pw">本部パスワード一括設定</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/import_branch_office_pw">支社・支店・AMパスワード一括設定</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/import_shop_pw">店舗管理者パスワード一括設定</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/import_callcenter_pw">コールセンターパスワード一括設定</router-link>
				</div>
				<div>
					<router-link class="uk-card uk-card-default uk-card-body uk-display-block" to="/cgt_manage/master/system_setting">システム設定</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Role from '@/api/Role'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import StaffAuth from '@/api/StaffAuth'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import CgtManageAuth from '@/api/CgtManageAuth'

	export default {
		name: 'CgtManageHomePage',
		comments: [],
		data () {
			return {}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY年MM月DD日 HH時mm分')
			}
		},
		methods: {
			clickLogoutButton () {
				let self = this

				let return_url = '/cgt_manage/login'

				// StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								CgtManageAuth.logout().then(function (response) {
									self.$router.push(return_url)
									location.reload()
								})
							// })
						// })
					// })
				// })
			},
			created () {
			},
			beforeMount () {
			}
		},
		mounted () {
			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_cgt_manage != true) { // 権限が無い場合
					self.$router.push('/cgt_manage/login')
				}
			})
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	#cgt_manage_link_list > div a {
		border: solid 1px #DDD;
	}
</style>



// WEBPACK FOOTER //
// src/components/page/CgtManageHomePage.vue